export default {
  catCard: {},
  catRanking: [],
};
